import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { formatCommas } from 'components/project/ClerkScreen/shared/utils/common';

const AskingBidValue = ({ showCurrencySymbol }) => {
  const {
    BidStore: { auction },
  } = useStores();

  const { nextBid } = auction;
  const formattedCurrency = showCurrencySymbol ? `$ ${formatCommas(nextBid)}` : formatCommas(nextBid);

  return <h1 data-testid="asking-bid">{nextBid && formattedCurrency}</h1>;
};

AskingBidValue.propTypes = {
  showCurrencySymbol: PropTypes.bool,
};

AskingBidValue.defaultProps = {
  showCurrencySymbol: true,
};


export default observer(AskingBidValue);
